import type { ContentType } from "@/api/content";

interface ContentTypeOption {
  value: ContentType;
  nl: string;
  en: string;
  nlHelp: string;
  enHelp: string;
}

export const CONTENT_TYPE_OPTIONS: ContentTypeOption[] = [
  { value: "document", nl: "Document", en: "Document", nlHelp: "Markdown-tekst met optionele bijlagen (PDF/afbeelding).", enHelp: "Markdown text with optional attachments (PDF/image)." },
  { value: "rule", nl: "Regel / beleid", en: "Rule / policy", nlHelp: "Zoals een document; meestal met 'akkoord vereist'.", enHelp: "Like a document; usually with 'sign-off required'." },
  { value: "workflow", nl: "Workflow", en: "Workflow", nlHelp: "Bouw een flowchart: knooppunten slepen en verbinden.", enHelp: "Build a flowchart: drag and connect nodes." },
  { value: "checklist", nl: "Checklist", en: "Checklist", nlHelp: "Een lijst met punten om door te lopen.", enHelp: "A list of items to go through." },
  { value: "contact_card", nl: "Contactkaart", en: "Contact card", nlHelp: "Eén of meer contactpersonen met functie en gegevens.", enHelp: "One or more contacts with role and details." },
  { value: "video", nl: "Video", en: "Video", nlHelp: "Een YouTube-, Vimeo- of MP4-link die wordt ingesloten.", enHelp: "A YouTube, Vimeo or MP4 link, embedded inline." },
  { value: "link", nl: "Link", en: "Link", nlHelp: "Een verzameling externe links als kaarten.", enHelp: "A set of external links shown as cards." },
];

export function contentTypeHelp(value: string, t: (nl: string, en: string) => string): string {
  const o = CONTENT_TYPE_OPTIONS.find((x) => x.value === value);
  return o ? t(o.nlHelp, o.enHelp) : "";
}

export const STATUS_TONE: Record<string, "ok" | "warn" | "neutral"> = {
  published: "ok",
  draft: "warn",
  archived: "neutral",
};

export function contentTypeLabel(value: string, t: (nl: string, en: string) => string): string {
  const o = CONTENT_TYPE_OPTIONS.find((x) => x.value === value);
  return o ? t(o.nl, o.en) : value;
}
